import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useState } from "react";
import { Check, CaretUpDown } from "@phosphor-icons/react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export function TextField({ label, value, onChange, type = "text", testId, col = 1, ...rest }) {
  return (
    <div className={col === 2 ? "sm:col-span-2" : ""}>
      <Label className="text-xs">{label}</Label>
      <Input
        type={type}
        data-testid={testId}
        value={value ?? ""}
        onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? "" : parseFloat(e.target.value)) : e.target.value)}
        className="rounded-sm mt-1"
        {...rest}
      />
    </div>
  );
}

export function AreaField({ label, value, onChange, testId }) {
  return (
    <div className="sm:col-span-2">
      <Label className="text-xs">{label}</Label>
      <Textarea data-testid={testId} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="rounded-sm mt-1" rows={2} />
    </div>
  );
}

export function SelectField({ label, value, onChange, options, testId, col = 1, placeholder = "Selecciona…" }) {
  return (
    <div className={col === 2 ? "sm:col-span-2" : ""}>
      <Label className="text-xs">{label}</Label>
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid={testId} className="rounded-sm mt-1">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="bg-popover border border-border max-h-72">
          {(options || []).filter((o) => o.value !== "" && o.value != null).map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export function SearchSelectField({ label, value, onChange, options, testId, col = 1, placeholder = "Selecciona…" }) {
  const [open, setOpen] = useState(false);
  const list = options || [];
  const current = list.find((o) => o.value === value);
  return (
    <div className={col === 2 ? "sm:col-span-2" : ""}>
      <Label className="text-xs">{label}</Label>
      <Popover open={open} onOpenChange={setOpen} modal>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testId} className="mt-1 flex h-9 w-full items-center justify-between rounded-sm border border-input bg-transparent px-3 text-sm text-left">
            <span className={`truncate ${current ? "" : "text-muted-foreground"}`}>{current ? current.label : placeholder}</span>
            <CaretUpDown size={14} className="opacity-50 shrink-0" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="p-0 w-[--radix-popover-trigger-width] rounded-sm" align="start">
          <Command filter={(v, s) => (v.split("__")[0].toLowerCase().includes(s.toLowerCase()) ? 1 : 0)}>
            <CommandInput placeholder="Buscar…" data-testid={`${testId}-search`} />
            <CommandList className="max-h-60 overflow-y-auto">
              <CommandEmpty>Sin resultados</CommandEmpty>
              {list.map((o) => (
                <CommandItem key={o.value} value={`${o.label}__${o.value}`} data-testid={`${testId}-opt-${o.value}`} onSelect={() => { onChange(o.value); setOpen(false); }}>
                  <Check size={14} className={`mr-2 ${o.value === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{o.label}</span>
                </CommandItem>
              ))}
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
}
